import { compose, withState, withProps, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { setReturningUser as setReturningUserAction } from '../../../core/auth';
import { fetchUsersInfo } from '../../../core/app/util';
import { checkUserSession, signUserIn } from '../../../core/auth/util';
import { LocalStorage, retrieveUriParam } from '../../../utils/helpers';

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setReturningUser: setReturningUserAction }, dispatch);

export default compose(
  connect(
    ({ authentication: { returningUser, client } }) => ({ returningUser, client }),
    mapDispatchToProps
  ),
  withState('credentials', 'setcredentials', { username: '', password: '' }),
  withState('useAnotherAccount', 'setUseAnotherAccount', false),
  withState('submitting', 'setSubmitting', false),
  withState('usersInfo', 'setUsersInfo', {}),
  withState('usersTokens', 'setUsersTokens', {}),
  withState('users', 'setUsers', []),
  withState('removeAccounts', 'setRemoveAccounts', false),
  withState('buttonText', 'setButtonText', 'SIGN ON'),
  withProps({ registerUri: retrieveUriParam('register_uri') }),
  withHandlers({
    validatePassword: () => ({ password, passwordConfirm }) => {
      if (password) {
        if (
          password.length < 8 ||
          !password.match(/[A-Z]+/) ||
          !password.match(/[a-z]+/) ||
          !password.match(/[!@#$%^&*)(+=._\-[\]]+/)
        ) {
          return {
            password:
              'Password must contain a minimum of 8 characters, 1 uppercase, 1 lowercase and 1 special character'
          };
        } else if (password !== passwordConfirm) {
          return { passwordConfirm: 'Password confirmation does not match password' };
        }
      }

      return {};
    },
    handleOnLogin: () => async ({ email, password }) => {
      const results = await signUserIn({ Username: email, Password: password });
      return results;
    },

    toggleUseAnotherAccount: ({ setUseAnotherAccount }) => () => setUseAnotherAccount(n => !n),
    returningLogin: ({ setReturningUser }) => ({ firstName, email }) => {
      setReturningUser({ firstName, email });
    },
    onBack: ({ setReturningUser, clearMessage }) => () => {
      setReturningUser({ email: null, firstName: null });
      clearMessage();
    },
    toggleRemoveAccounts: ({ setRemoveAccounts }) => () => setRemoveAccounts(s => !s),
    removeAccount: ({ setUsers, setUsersTokens }) => email => {
      setUsers(users => {
        const newUsers = users.filter(u => u !== email);
        LocalStorage.setObject('usernames', newUsers);
        return newUsers;
      });
      setUsersTokens(usersTokens => {
        const newUsersTokens = { ...usersTokens };
        delete newUsersTokens[email];
        LocalStorage.setObject('usersTokens', newUsersTokens);
        return newUsersTokens;
      });
    }
  }),
  lifecycle({
    async componentDidMount() {
      const { setUsers, setUsersInfo, setUsersTokens } = this.props;

      const users = LocalStorage.getArray('usernames');
      setUsers(users);

      await checkUserSession();
      const usersTokens = await checkUserSession();
      setUsersTokens(usersTokens);

      const usersInfo = await fetchUsersInfo(users);
      setUsersInfo(usersInfo);
    },
    componentWillUpdate(nextProps) {
      if (nextProps.message && nextProps.message !== this.props.message) {
        this.props.setButtonText('SIGN ON');
        this.props.setSubmitting(false);
      }
    }
  })
);



// WEBPACK FOOTER //
// ./src/views/sports-connect/containers/LoginEnhancer.js